import { getLocaleToUse } from "../../../components-shared/utils/language.js";
import { BaseRedomElement } from "../../utils/base-redom-element.js";
import { DeliveryGroupList } from "./delivery-group-list.js"
import { DeliveryOptionList } from "./delivery-option-list.js";
import { DeliverySelectorStateManager } from "./delivery-selector-state-manager.js";
import { ICmsDeliverySelectorConfiguration } from "./interfaces/cms-delivery-selector-config-interface.js";
import { IDeliverySelectorOutputOption } from "./interfaces/delivery-selector-output-option-interface.js";
import { IDeliverySelectorData } from "../../api/estore/checkout/interfaces/delivery-selector-data-interface.js";

export class DeliverySelector extends BaseRedomElement {
    readonly AVAILABLE_LOCALES: string[] = ["nb", "en"];
    readonly TRANSLATIONS_BASE_PATH = "./translations/delivery-selector.[LOCALE].js";

    userLocales: string[] = null;
    stateManager: DeliverySelectorStateManager;
    config: ICmsDeliverySelectorConfiguration;
    translations: any = null;
    created: boolean;
    children: any;
    root: Node;

    constructor(config: ICmsDeliverySelectorConfiguration, data: IDeliverySelectorData, userLocales: string[]) {
        super(config.useShadowRoot);
        this.userLocales = userLocales;
        this.config = config;
        this.root = this.config.useShadowRoot ? this.shadowRoot : this;
        this.stateManager = new DeliverySelectorStateManager(data);
        this.stateManager.stateReplaceDelegates.push(() => this.render());   
    }

    async update(data: IDeliverySelectorData) {
        this.stateManager.replaceState(data);
    }

    async connectedCallback() {
        await this.render();
    }

    onSelectedOptionChanged(delegate: { (selectedOption: IDeliverySelectorOutputOption) : void }) {
        this.stateManager.outputStateManager.onSelectedChanged.push(delegate);
    }

    onOptionPropertyChanged(delegate: { (selectedOption: IDeliverySelectorOutputOption) : void }) {
        this.stateManager.outputStateManager.onPropertiesChanged.push(delegate);
    }

    async render() {
        if (!this.translations) {
            this.translations = await this.loadTranslations();
        }

        if (this.created === true) {
            this.unmountArray(this.root, [this.children.styles, this.children.groupList, ...this.children.optionsLists]);
        }

        this.created = true;

        const data = this.stateManager.state;
        
        this.children.styles = this.config.useShadowRoot ? this.element("styles", "link", { rel: "stylesheet", href: this.config.cssFiles.deliverySelector}) : null;
        this.children.groupList = new DeliveryGroupList(this.config, this.stateManager, this.translations);
        this.children.optionsLists = data.groups.map(g => new DeliveryOptionList(this.config, this.stateManager, this.translations, g));

        this.mountArray(this.root, [this.children.styles, this.children.groupList, ...this.children.optionsLists]);
    }

    async loadTranslations() {
        const locale = getLocaleToUse(this.AVAILABLE_LOCALES, this.userLocales);
        const path = this.TRANSLATIONS_BASE_PATH.replace("[LOCALE]", locale);
        const translationModule = await import(path);
        return translationModule.default;
    }
}

customElements.define('delivery-selector', DeliverySelector);